import React from 'react';
import ReactDOM from 'react-dom/client';
import './responsive.css';
import App from './App';
import LoginGate from './components/LoginGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LoginGate>
    <App />
  </LoginGate>
);
